import { HttpEvent, HttpHandler, HttpHandlerFn, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { Observable } from "rxjs";
import { AuthService } from "../../services/auth.service";
import { ENVIRONMENT } from "src/environments/environment";

export function beforeSendInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (req.url.includes(ENVIRONMENT.API_URL))
    switch (req.method) {
      case "GET":
        return getInterceptor(req, next);

      case "POST":
        return postInterceptor(req, next);
    }
  return next(req.clone());
}

function getInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const auth = inject(AuthService);
  const requestTime = new Date().getTime().toString();

  const obj: Record<string, string> = {
    _: requestTime,
  };
  if (auth.tabindex) obj.tabindex = auth.tabindex;

  return next(
    req.clone({
      setParams: obj,
      withCredentials: true,
    }),
  );
}

function postInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const auth = inject(AuthService);
  const requestTime = new Date().getTime().toString();

  let body = req.body;
  const time = requestTime;
  const index = auth.tabindex;

  if (req.body instanceof FormData) {
    if (index) (<FormData>body).set("tabindex", index || "");
  } else {
    body = {
      ...(<object>req.body),
      _: time,
      tabindex: index || undefined,
    };
  }

  return next(
    req.clone({
      body: body,
      withCredentials: true,
    }),
  );
}

export class BeforeSendInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return beforeSendInterceptor(req, next.handle);
  }
}
